import { Checkbox } from "primereact/checkbox";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function QueSettings({question,courseId,questionType,onChange})
{
    const {t}=useTranslation();
    const [mixOpts,setMixOpts]=useState(question.mixOpts);
    useEffect(()=>{
        console.log('QueSettings:construstor:qType='+questionType);
    },[]);
    useEffect(()=>{

    },[questionType]);
    const changed=(q)=>{
        onChange(q);
    };
    const onMixOptsChange=(e)=>{
        setMixOpts(e.target.checked);
        changed({mixOpts:e.target.checked});
    };    
    const mixOptClass=`${(questionType!='MC' && questionType!='MR')?'hidden':'flex align-items-center col-12'}`;
    return(
        <>
			<div className="formgrid grid p-4 surface-ground gap-4">
				<div className={mixOptClass}>
					<Checkbox inputId="mixChoices" checked={mixOpts} onChange={onMixOptsChange}></Checkbox>
                    <label htmlFor="mixChoices" className="ml-2">{t('Allow_mixing_options')}</label>
				</div>
				<div className="flex align-items-center col-12">
					<Checkbox inputId="allowOthers"></Checkbox>
                    <label htmlFor="allowOthers" className="ml-2">{t('Allow_other_authors')}</label>
				</div>
            </div>
        </>
    )
}